
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getloginLog } from '@/api/merchant/merchant'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import { getMerchantManagerList } from '@/api/merchant/manager'

@Component({
  name: 'loginLog',
  components: {
    pagination
  }
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  private listLoading: boolean = true
  private listQuery = {
    page: 1,
    limit: 20
  }
  private queryForm: any = {
    manager: '',
    start_time: null,
    end_time: null
  }
  private list: any[] = []
  private total = 0
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions
  private managerForm: any = {}
  private managerList: any = []

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getloginLog(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange () {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      manager: '',
      start_time: null,
      end_time: null
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      // this.getloginLog(true)
      this.hadleGetFilesListApi()
      this.getList()
    })
  }

  // 获取登录日志
  private async getloginLog (isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    this.listLoading = true
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.queryForm
    }
    delObjEmptyKey(data)
    try {
      await getloginLog(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 获取管理员信息列表
  private async getList () {
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.managerForm
    }
    this.listLoading = true
    await getMerchantManagerList(data).then((res: any) => {
      this.managerList = res.results
      this.listLoading = false
    })
  }

  private async remoteQuery (query: string) {
    const params = {
      username: query,
      merchant_no: this.merchant_no
    }
    await getMerchantManagerList(params).then((res: any) => {
      this.managerList = res.results
    })
  }

  mounted () {
    // this.getloginLog(true)
    this.hadleGetFilesListApi()
    this.getList()
  }
}
